import React from "react";
import DatePicker from "../../../../../../components/ui/calendar/date_picket/DatePicker";
import ICDCodeSelectionCompoonent from "../../../../../../components/icd/ICDCodeSelectionCompoonent";

export default function ICD10Component({defaultValues,onUserInput}) {
  return (
    <ICDCodeSelectionCompoonent
      className={`form-control form-control-sm text-start p-0 m-0 text-primary`}
      style={{}}
      type={"Date"}
      defaultValue={defaultValues ?? ""}
      onSelected={(d) => onUserInput(d)}
    />
  );
}
